import React from 'react';
import { Button, message, Form, InputNumber } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import modal from '~components/modal';
import { MODIFY_INVOICE_NUMBER } from '~pages/dashboard/reconciliation/booking-details/edit-actual-invoiced/queries';

function EditActualInvoiced({ opportunityDetail, onClose, onConfirm, form, value }) {
  const { t } = useTranslation();
  const { getFieldDecorator } = form;

  const [updateCommission, { loading: updateCommissionLoading }] = useMutation(
    MODIFY_INVOICE_NUMBER,
    {
      onError: e => {
        message.error(e.message);
      },
    },
  );

  const handleSubmit = async () => {
    form.validateFieldsAndScroll(async err => {
      if (err) {
        message.warn(t('cms.reconciliation.booking.invoice_editor.submit.error'));
        return;
      }
      const formData = form.getFieldsValue();
      const actualInvoicedValue = formData.actualInvoicedValue;
      if (actualInvoicedValue) {
        console.log(formData, 'formData');
        const response = await updateCommission({
          variables: {
            input: {
              id: opportunityDetail?.completedXbooking?.commission?.id,
              data: {
                actualInvoicedValue: Number(actualInvoicedValue),
              },
            },
          },
        });

        if (response?.data?.updateCommission?.result) {
          message.success('Actual invoiced value successfully updated.');
          onConfirm();
          onClose();
        }
      }
    });
  };

  return (
    <div className="partner-register-city-editor invoice-editor">
      <div className="partner-register-city-editor__header invoice-editor__header">
        Edit actual invoiced value
        <CloseOutlined className="partner-register-city-editor__close-button" onClick={onClose} />
      </div>
      <div className="partner-register-city-editor__body">
        <section className="partner-reassign-editor__section partner-register-city-editor__main">
          <main className="partner-reassign-editor__main invoice-editor__form">
            <div className={classNames('partner-reassign-editor__form-item')}>
              <h3 style={{ fontSize: '14px' }} className="partner-reassign-editor__selector-title">
                Actual invoiced value:
              </h3>
              <Form.Item required={false}>
                {getFieldDecorator(`actualInvoicedValue`, {
                  initialValue: value,
                })(<InputNumber placeholder="Actual invoiced value" />)}
              </Form.Item>
            </div>
          </main>
        </section>
      </div>
      <div className="partner-register-city-editor__footer">
        <Button
          size="large"
          className="partner-register-city-editor__cancel-button"
          onClick={onClose}
        >
          {t('cms.referral.partner.detail.editor.btn.cancel')}
        </Button>
        <Button
          type="primary"
          size="large"
          className="partner-register-city-editor__save-button"
          loading={updateCommissionLoading}
          onClick={handleSubmit}
        >
          {t('cms.referral.partner.detail.editor.btn.save')}
        </Button>
      </div>
    </div>
  );
}

EditActualInvoiced.propTypes = {
  onClose: PropTypes.func.isRequired,
  value: PropTypes.string,
};

EditActualInvoiced.defaultProps = {
  onClose: () => {},
  value: null,
};

export default Form.create()(
  modal(
    {
      className: 'partner-register-city-editor-modal',
    },
    true,
  )(EditActualInvoiced),
);
